var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"self",class:_vm.className,style:(_vm.style),on:{"mousedown":_vm.mousedown,"touchstart":function($event){$event.stopPropagation();return _vm.mousedown($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }